import api from './api'

export interface Room {
  _id: string
  schoolId: string
  type: 'PRIVATE' | 'DOUBLE' | 'TRIPLE' | 'QUADRUPLE' | 'CUSTOM'
  name: string
  capacity: number
  notes?: string
  images?: string[]
  video?: string
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateRoomData {
  type: Room['type']
  name: string
  capacity: number
  notes?: string
  images?: string[]
  video?: string
  isActive?: boolean
}

export interface UpdateRoomData extends Partial<CreateRoomData> {}

class RoomService {
  /**
   * Get all rooms for a school
   */
  async getSchoolRooms(schoolId: string, isActive?: boolean): Promise<Room[]> {
    const params = isActive !== undefined ? { isActive: String(isActive) } : {}
    const response = await api.get(`/rooms/school/${schoolId}`, { params })
    console.log('Room API response:', response) // Debug log
    // api.get() already returns response.data, so response is { success: true, data: rooms }
    const rooms = response?.data || []
    console.log('Rooms extracted:', rooms) // Debug log
    return Array.isArray(rooms) ? rooms : []
  }

  /**
   * Get room by ID
   */
  async getRoomById(roomId: string): Promise<Room> {
    const response = await api.get(`/rooms/${roomId}`)
    return response.data?.data ?? response.data
  }

  /**
   * Create a new room
   */
  async createRoom(schoolId: string, data: CreateRoomData): Promise<Room> {
    const response = await api.post(`/rooms/school/${schoolId}`, data)
    return response.data?.data ?? response.data
  }

  /**
   * Update a room
   */
  async updateRoom(roomId: string, data: UpdateRoomData): Promise<Room> {
    const response = await api.put(`/rooms/${roomId}`, data)
    return response.data?.data ?? response.data
  }

  /**
   * Delete a room
   */
  async deleteRoom(roomId: string): Promise<void> {
    await api.delete(`/rooms/${roomId}`)
  }

  /**
   * Toggle room status
   */
  async toggleRoomStatus(roomId: string): Promise<Room> {
    const response = await api.patch(`/rooms/${roomId}/toggle-status`)
    return response.data?.data ?? response.data
  }
}

export default new RoomService()

